// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".basis[data-v-c29318be]{flex-basis:48%}svg[data-v-c29318be]{width:40px}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Details.vue"],"names":[],"mappings":"AACA,wBACI,cAAJ,CAGA,qBACI,UAAJ","sourcesContent":["\n.basis {\n    flex-basis: 48%;\n}\n\nsvg {\n    width:40px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
